import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

/** 域名分类与站点（前端静态数据，策略编辑用） */
export interface DomainSiteItem {
  title: string
  domain: string
}

export interface DomainCategoryBlock {
  /** 展示用中文名（兜底）；多语言用 categoryI18nKey */
  category: string
  /** accessRestriction.domainCategory.<key> */
  categoryI18nKey: string
  sites: DomainSiteItem[]
}
// 日文专版
export const domainCategoryWebsiteDataJP =
[
  {
    "category": "よく使う",
    "categoryI18nKey": "frequently_used",
    "sites": [
      { "title": "TEMU", "domain": "temu.co.jp" },
      { "title": "Yahoo!", "domain": "yahoo.co.jp" },
      { "title": "YouTube", "domain": "youtube.com" },
      { "title": "Facebook", "domain": "facebook.com" },
      { "title": "Google", "domain": "google.co.jp" },
      { "title": "ニコニコ動画", "domain": "nicovideo.jp" },
      { "title": "アメーバ (Ameba)", "domain": "ameba.jp" },
      { "title": "Twitter (X)", "domain": "x.com" },
      { "title": "hulu", "domain": "hulu.jp" },
      { "title": "楽天市場", "domain": "rakuten.co.jp" },
      { "title": "Amazon", "domain": "amazon.co.jp" },
      { "title": "Yahoo! ショッピング", "domain": "shopping.yahoo.co.jp" },
      { "title": "Gmail", "domain": "mail.google.com" },
      { "title": "楽天トラベル", "domain": "travel.rakuten.co.jp" },
      { "title": "じゃらん", "domain": "jalan.net" },
      { "title": "Hotels.com", "domain": "jp.hotels.com" },
      { "title": "Yahoo! オークション", "domain": "auctions.yahoo.co.jp" },
      { "title": "pixiv", "domain": "pixiv.net" },
      { "title": "goo", "domain": "goo.ne.jp" },
      { "title": "Livedoor", "domain": "livedoor.jp" },
      { "title": "BIGLOBE", "domain": "biglobe.ne.jp" },
      { "title": "Infoseek", "domain": "infoseek.co.jp" },
      { "title": "mixi", "domain": "mixi.jp" },
      { "title": "Hot Pepper", "domain": "hotpepper.jp" },
      { "title": "Gravity", "domain": "gravity.jp" },
      { "title": "Uber Eats", "domain": "ubereats.com/jp" }
    ]
  },
  {
    "category": "ゲーム",
    "categoryI18nKey": "games",
    "sites": [
      { "title": "ロードス島戦記オンライン", "domain": "lodoss.ch" },
      { "title": "モバゲー", "domain": "mbga.jp" },
      { "title": "Minecraft", "domain": "minecraft.net/ja-jp" },
      { "title": "ハンゲーム", "domain": "hangame.co.jp" },
      { "title": "Yahoo! ゲーム", "domain": "game.yahoo.co.jp" },
      { "title": "Appliv（アプリヴ）", "domain": "appliv.com" },
      { "title": "任天堂", "domain": "nintendo.co.jp" },
      { "title": "ラグナロクオンライン", "domain": "ragnarok-online.jp" },
      { "title": "4Gamer", "domain": "4gamer.net" }
    ]
  },
  {
    "category": "ニュース",
    "categoryI18nKey": "news",
    "sites": [
      { "title": "読売新聞", "domain": "yomiuri.co.jp" },
      { "title": "朝日新聞", "domain": "asahi.com" },
      { "title": "Yahoo! ニュース", "domain": "news.yahoo.co.jp" },
      { "title": "日本経済新聞", "domain": "nikkei.com" },
      { "title": "産経ニュース", "domain": "sankei.com" },
      { "title": "Google ニュース", "domain": "news.google.co.jp" },
      { "title": "毎日新聞", "domain": "mainichi.jp" },
      { "title": "時事通信社", "domain": "jiji.com" },
      { "title": "CNN JP", "domain": "cnn.co.jp" },
      { "title": "聯合ニュース", "domain": "japan.yonhapnews.co.kr" }
    ]
  },
  {
    "category": "メールアドレス",
    "categoryI18nKey": "email",
    "sites": [
      { "title": "Yahoo! メール", "domain": "mail.yahoo.co.jp" },
      { "title": "Gmail", "domain": "mail.google.com" },
      { "title": "Outlook", "domain": "outlook.office.com" },
      { "title": "goo メール", "domain": "mail.goo.ne.jp" },
      { "title": "excite メール", "domain": "mail.excite.co.jp" },
      { "title": "AOL メール", "domain": "mail.aol.co.jp" }
    ]
  },
  {
    "category": "動画",
    "categoryI18nKey": "video",
    "sites": [
      { "title": "TSUTAYA TV", "domain": "tv.tsutaya.co.jp" },
      { "title": "YouTube", "domain": "youtube.com" },
      { "title": "ニコニコ動画", "domain": "nicovideo.jp" },
      { "title": "FC2 動画", "domain": "video.fc2.com" },
      { "title": "Hulu (フールー)", "domain": "hulu.jp" },
      { "title": "ひまわり", "domain": "himawari.live" },
      { "title": "U-NEXT", "domain": "video.unext.jp" },
      { "title": "Amazon インスタント・ビデオ", "domain": "amazon.co.jp/gp/video" },
      { "title": "WOWOW オンライン", "domain": "wowow.co.jp" },
      { "title": "DMM 動画見放題 ch", "domain": "dmm.co.jp" }
    ]
  },
  {
    "category": "地図・マップ",
    "categoryI18nKey": "maps",
    "sites": [
      { "title": "Google マップ", "domain": "google.co.jp/maps" },
      { "title": "Yahoo! 地図", "domain": "map.yahoo.co.jp" },
      { "title": "Mapion", "domain": "mapion.co.jp" },
      { "title": "NAVITIME", "domain": "navitime.co.jp" },
      { "title": "いつも NAVI", "domain": "its-mo.com" },
      { "title": "goo 地図", "domain": "map.goo.ne.jp" },
      { "title": "Google Earth", "domain": "earth.google.com" },
      { "title": "MapFan", "domain": "mapfan.com" }
    ]
  },
  {
    "category": "旅行",
    "categoryI18nKey": "travel",
    "sites": [
      { "title": "きっぷ ONLINE", "domain": "kip-online.jp" },
      { "title": "Yahoo! トラベル", "domain": "travel.yahoo.co.jp" },
      { "title": "楽天トラベル", "domain": "travel.rakuten.co.jp" },
      { "title": "じゃらん", "domain": "jalan.net" },
      { "title": "るるぶトラベル", "domain": "rurubu.travel" },
      { "title": "H.I.S.", "domain": "his-j.com" },
      { "title": "JTB", "domain": "jtb.co.jp" },
      { "title": "エクスペディア", "domain": "expedia.co.jp" },
      { "title": "一休.com", "domain": "ikyu.com" },
      { "title": "DeNA トラベル", "domain": "travel.mobage.jp" }
    ]
  },
  {
    "category": "情報",
    "categoryI18nKey": "information",
    "sites": [
      { "title": "Yahoo! 天気情報", "domain": "weather.yahoo.co.jp" },
      { "title": "テレビ番組表", "domain": "tv.yahoo.co.jp" },
      { "title": "郵便番号検索", "domain": "search.post.japanpost.jp" },
      { "title": "人力検索はてな", "domain": "hatena.ne.jp" },
      { "title": "OKWave", "domain": "okwave.jp" },
      { "title": "ウィキペディア", "domain": "ja.wikipedia.org" },
      { "title": "Google 翻訳", "domain": "translate.google.co.jp" },
      { "title": "Weblio 辞書", "domain": "weblio.jp" }
    ]
  },
  {
    "category": "金融",
    "categoryI18nKey": "finance",
    "sites": [
      { "title": "保険マンモス", "domain": "hoken-mammoth.jp" },
      { "title": "自動車保険比較", "domain": "ins-kuruma.com" },
      { "title": "三井住友 VISA カード", "domain": "smbc-card.com" },
      { "title": "楽天カード", "domain": "rakuten-card.co.jp" },
      { "title": "ワイジェイ FX", "domain": "yjfx.co.jp" },
      { "title": "三菱東京 UFJ 銀行", "domain": "bk.mufg.jp" },
      { "title": "三井住友銀行", "domain": "smbc.co.jp" },
      { "title": "みずほ銀行", "domain": "mizuhobank.co.jp" },
      { "title": "生命保険見直し", "domain": "life-hoken-navi.jp" }
    ]
  },
  {
    "category": "スポーツ",
    "categoryI18nKey": "sports",
    "sites": [
      { "title": "スポニチ", "domain": "sponichi.co.jp" },
      { "title": "Yahoo! スポーツ", "domain": "sports.yahoo.co.jp" },
      { "title": "ゴルフダイジェスト", "domain": "golfdigest.co.jp" },
      { "title": "スポーツナビ", "domain": "sportsnavi.yahoo.co.jp" },
      { "title": "サンスポ", "domain": "sanspo.com" },
      { "title": "デイリースポーツ", "domain": "daily.co.jp" },
      { "title": "Yahoo! プロ野球", "domain": "baseball.yahoo.co.jp" },
      { "title": "Yahoo! 大相撲", "domain": "sumo.yahoo.co.jp" },
      { "title": "アディダス", "domain": "adidas.co.jp" },
      { "title": "JRA", "domain": "jra.go.jp" }
    ]
  },
  {
    "category": "交通情報",
    "categoryI18nKey": "traffic",
    "sites": [
      { "title": "Yahoo! 路線情報", "domain": "transit.yahoo.co.jp" },
      { "title": "JARTIC", "domain": "jartic.or.jp" },
      { "title": "NAVITIME", "domain": "navitime.co.jp" },
      { "title": "駅探", "domain": "ekitan.com" },
      { "title": "JR 東日本", "domain": "jreast.co.jp" },
      { "title": "ANA", "domain": "ana.co.jp" },
      { "title": "Google 乗換案内", "domain": "google.co.jp/transit" },
      { "title": "ドラぷら", "domain": "drive.plala.or.jp" },
      { "title": "日本旅行", "domain": "nta.co.jp" },
      { "title": "4travel", "domain": "4travel.jp" }
    ]
  },
  {
    "category": "芸能ニュース",
    "categoryI18nKey": "entertainment",
    "sites": [
      { "title": "スポニチ", "domain": "sponichi.co.jp" },
      { "title": "日刊サイゾー", "domain": "cyzo.com" },
      { "title": "芸能 7days", "domain": "geinou7days.com" },
      { "title": "Excite エンタメ", "domain": "excite.co.jp/entertainment" },
      { "title": "ZAKZAK", "domain": "zakzak.co.jp" },
      { "title": "日本タレント名鑑", "domain": "talent-navi.jp" },
      { "title": "Ameba 芸能人ブログ", "domain": "ameblo.jp" },
      { "title": "ハリウッドゴシップ", "domain": "hollywood-gossip.jp" }
    ]
  },
  {
    "category": "グルメ",
    "categoryI18nKey": "gourmet",
    "sites": [
      { "title": "楽天レシピ", "domain": "recipe.rakuten.co.jp" },
      { "title": "クックパッド", "domain": "cookpad.com" },
      { "title": "食べログ", "domain": "tabelog.com" },
      { "title": "ぐるなび", "domain": "gnavi.co.jp" },
      { "title": "ホットペッパー", "domain": "hotpepper.jp" },
      { "title": "出前館", "domain": "demae-can.com" },
      { "title": "Rettey グルメ", "domain": "rettey.jp" },
      { "title": "ぐるめぱど", "domain": "gurumepado.jp" },
      { "title": "Yahoo! ロコ", "domain": "loco.yahoo.co.jp" },
      { "title": "グルーポン", "domain": "groupon.jp" }
    ]
  },
  {
    "category": "格安スマホ・SIM",
    "categoryI18nKey": "mobile_sim",
    "sites": [
      { "title": "Y!mobile", "domain": "ymobile.jp" },
      { "title": "楽天格安スマホ", "domain": "mobile.rakuten.co.jp" },
      { "title": "NifMo by NIFTY", "domain": "nifmo.nifty.com" },
      { "title": "SkyLinkMobile", "domain": "skylinkmobile.jp" },
      { "title": "楽天格安 SIM", "domain": "sim.rakuten.co.jp" },
      { "title": "Amazon 格安スマホ", "domain": "amazon.co.jp" },
      { "title": "UQ mobile", "domain": "uqmobile.jp" },
      { "title": "DMM mobile", "domain": "dmm-mobile.jp" },
      { "title": "TSUTAYA のスマホ TONE", "domain": "tone.ne.jp" }
    ]
  },
  {
    "category": "パソコン",
    "categoryI18nKey": "computer",
    "sites": [
      { "title": "窓の杜", "domain": "forest.watch.impress.co.jp" },
      { "title": "レノボ・ジャパン", "domain": "lenovo.com/jp" },
      { "title": "アップル", "domain": "apple.com/jp" },
      { "title": "Microsoft Japan", "domain": "microsoft.com/ja-jp" },
      { "title": "Vector", "domain": "vector.co.jp" },
      { "title": "Impress Watch", "domain": "watch.impress.co.jp" },
      { "title": "ITmedia", "domain": "itmedia.co.jp" },
      { "title": "ドスパラ", "domain": "dospara.co.jp" }
    ]
  },
  {
    "category": "賃貸・不動産",
    "categoryI18nKey": "real_estate",
    "sites": [
      { "title": "SUUMO", "domain": "suumo.jp" },
      { "title": "マイナビ賃貸", "domain": "chintai.mynavi.jp" },
      { "title": "CHINTAI", "domain": "chintai.net" },
      { "title": "セキスイハイム", "domain": "sekisuiheim.com" },
      { "title": "スマイティ", "domain": "smity.jp" },
      { "title": "引越達人セレクト", "domain": "hikkoshi-tatsujin.jp" },
      { "title": "レオパレス 21", "domain": "leopalace21.com" },
      { "title": "住友不動産販売", "domain": "sumitomo-fudo.co.jp" },
      { "title": "オウチーノ", "domain": "ouchino.jp" },
      { "title": "ニフティ不動産", "domain": "fudosan.nifty.com" }
    ]
  },
  {
    "category": "転職・求人情報",
    "categoryI18nKey": "recruitment",
    "sites": [
      { "title": "リクルートエージェント", "domain": "agent.recruit.co.jp" },
      { "title": "リクナビ NEXT", "domain": "next.rikunabi.com" },
      { "title": "マイナビエージェント", "domain": "agent.mynavi.jp" },
      { "title": "マイナビバイト", "domain": "baito.mynavi.jp" },
      { "title": "はたらこねっと", "domain": "hatarakonet.jp" },
      { "title": "ジョブセンス", "domain": "jobsense.jp" },
      { "title": "バイト探すなら an", "domain": "an.jp" },
      { "title": "フロムエーナビ", "domain": "froma.yahoo.co.jp" }
    ]
  }
] as DomainCategoryBlock[]

const domainCategoryWebsiteDataCN: DomainCategoryBlock[] = [
  {
    category: "博彩网站",
    categoryI18nKey: "gambling",
    sites: [
      { title: "espnstar中文网", domain: "espnstar.com.cn" },
      { title: "爱波网", domain: "betcn.com" },
      { title: "彩通网", domain: "1778.net" },
      { title: "彩之网", domain: "cocololo.com" },
      { title: "福建体彩", domain: "c512.com" },
      { title: "广西彩票网", domain: "gxcaipiao.com" },
      { title: "国彩网", domain: "guocai.com" },
      { title: "华夏足彩", domain: "zucai.com" },
      { title: "千禧足球预测网", domain: "1000ab.com" },
      { title: "雪缘园", domain: "gooooal.com" },
      { title: "福彩网", domain: "16886000.com" },
      { title: "中彩网", domain: "zhcw.com" },
      { title: "中国彩票", domain: "cpiao.com" },
      { title: "中国体彩网", domain: "lottery.gov.cn" },
      { title: "中国足彩网", domain: "zgzcw.com" },
      { title: "足球博彩", domain: "zqbc.com" }
    ]
  },
  {
    category: "财经网站",
    categoryI18nKey: "finance",
    sites: [
      { title: "财经网", domain: "caijing.com.cn" },
      { title: "财新网", domain: "caixin.com" },
      { title: "第一财经", domain: "yicai.com" },
      { title: "凤凰财经", domain: "finance.ifeng.com" },
      { title: "和讯财经", domain: "hexun.com" },
      { title: "金融界", domain: "jrj.com.cn" },
      { title: "巨潮资讯", domain: "cninfo.com.cn" },
      { title: "巨丰财经", domain: "jfinfo.com" },
      { title: "摩尔投研", domain: "moer.cn" },
      { title: "全景网", domain: "p5w.net" },
      { title: "搜狐财经", domain: "business.sohu.com" },
      { title: "天天基金网", domain: "1234567.com.cn" },
      { title: "同花顺", domain: "10jqka.com.cn" },
      { title: "万隆证券网", domain: "wlstock.com" },
      { title: "网易财经", domain: "money.163.com" },
      { title: "新浪财经", domain: "finance.sina.com.cn" },
      { title: "雪球", domain: "xueqiu.com" },
      { title: "云财经网", domain: "yuncaijing.com" },
      { title: "证券时报", domain: "stcn.com" },
      { title: "证券之星", domain: "stockstar.com" },
      { title: "中财网", domain: "cfi.cn" },
      { title: "中国经济网", domain: "ce.cn" },
      { title: "中国网财经", domain: "finance.china.com.cn" },
      { title: "中国证券网", domain: "cnstock.com" },
      { title: "中金在线", domain: "cnfol.com" },
      { title: "中证网", domain: "cs.com.cn" }
    ]
  },
  {
    category: "房产网站",
    categoryI18nKey: "realEstate",
    sites: [
      { title: "0746房产网", domain: "fdc0746.com" },
      { title: "21世纪不动产", domain: "century21cn.com" },
      { title: "365房产网", domain: "house365.com" },
      { title: "e房网", domain: "efw.cn" },
      { title: "爱彼迎", domain: "airbnb.cn" },
      { title: "安居客", domain: "anjuke.com" },
      { title: "贝壳找房", domain: "ke.com" },
      { title: "第一时间房源网", domain: "01fy.cn" },
      { title: "房博士", domain: "fangdr.com" },
      { title: "房多多", domain: "fangdd.com" },
      { title: "房价网", domain: "fangjia.com" },
      { title: "房天下", domain: "fang.com" },
      { title: "房小二网", domain: "sy.fangxiaoer.com" },
      { title: "凤凰房产", domain: "house.ifeng.com" },
      { title: "好房子", domain: "haofz.com" },
      { title: "惠民之家", domain: "fz0752.com" },
      { title: "吉屋网", domain: "jiwu.com" },
      { title: "焦点房产网", domain: "focus.cn" },
      { title: "乐居房产", domain: "leju.com" },
      { title: "链家", domain: "lianjia.com" },
      { title: "楼盘网", domain: "loupan.com" },
      { title: "腾讯房产", domain: "house.qq.com" },
      { title: "网易房产", domain: "house.163.com" },
      { title: "我爱我家", domain: "5i5j.com" },
      { title: "新浪乐居", domain: "house.sina.com.cn" },
      { title: "亿房", domain: "fdc.com.cn" },
      { title: "中国房价行情", domain: "creprice.cn" },
      { title: "自如网", domain: "ziroom.com" },
      { title: "租铺客", domain: "zupuk.com" }
    ]
  },
  {
    category: "股票网站",
    categoryI18nKey: "stocks",
    sites: [
      { title: "安信证券", domain: "essence.com.cn" },
      { title: "渤海证券", domain: "ecom.cn" },
      { title: "财达证券", domain: "s10000.com" },
      { title: "财通证券", domain: "ctsec.com" },
      { title: "财信证券", domain: "hnchasing.com" },
      { title: "大同证券", domain: "dtsbc.com.cn" },
      { title: "德邦证券", domain: "tebon.com.cn" },
      { title: "第一创业", domain: "firstcapital.com.cn" },
      { title: "东北证券", domain: "nesc.cn" },
      { title: "东方财富网", domain: "eastmoney.com" },
      { title: "东方财富证券", domain: "xzsec.com" },
      { title: "东方证券", domain: "dfzq.com.cn" },
      { title: "东莞证券", domain: "dgzq.com.cn" },
      { title: "东海证券", domain: "longone.com.cn" },
      { title: "东吴证券", domain: "dwzq.com.cn" },
      { title: "东兴证券", domain: "dxzq.net" },
      { title: "方正证券", domain: "foundersc.com" },
      { title: "富途证券", domain: "futuhk.com" },
      { title: "股海网", domain: "guhai.com.cn" },
      { title: "股民天地", domain: "bjzq.com.cn" },
      { title: "股旁网", domain: "gupang.com" },
      { title: "股票之声", domain: "gupzs.com" },
      { title: "光大证券", domain: "ebscn.com" },
      { title: "广发证券", domain: "gf.com.cn" },
      { title: "国都证券", domain: "guodu.com" },
      { title: "国海证券", domain: "ghzq.com.cn" },
      { title: "国金证券", domain: "gjzq.com.cn" },
      { title: "国联证券", domain: "glsc.com.cn" },
      { title: "国泰君安", domain: "gtja.com" },
      { title: "国信证券", domain: "guosen.com.cn" },
      { title: "国元证券", domain: "gyzq.com.cn" },
      { title: "海通证券", domain: "htsec.com" },
      { title: "恒泰证券", domain: "cnht.com.cn" },
      { title: "红塔证券", domain: "hongtastock.com" },
      { title: "宏信证券", domain: "hxzq.cn" },
      { title: "华安证券", domain: "hazq.com" },
      { title: "华创证券", domain: "hczq.com" },
      { title: "华林证券", domain: "chinalions.com" },
      { title: "华龙证券", domain: "hlzqgs.com" },
      { title: "华融证券", domain: "hrsec.com.cn" },
      { title: "华泰证券", domain: "htsc.com.cn" },
      { title: "华西证券", domain: "hx168.com.cn" },
      { title: "华鑫证券", domain: "cfsc.com.cn" },
      { title: "金十数据", domain: "jin10.com" },
      { title: "金元证券", domain: "jyzq.cn" },
      { title: "开源证券", domain: "kysec.cn" },
      { title: "叩富模拟炒股", domain: "cofool.com" },
      { title: "老虎证券", domain: "itiger.com" },
      { title: "民生证券", domain: "mszq.com" },
      { title: "南方财富网", domain: "southmoney.com" },
      { title: "南京证券", domain: "njzq.com.cn" },
      { title: "牛仔网", domain: "9666.cn" },
      { title: "平安证券", domain: "stock.pingan.com" },
      { title: "散户大家庭", domain: "shdjt.com" },
      { title: "山西证券", domain: "i618.com.cn" },
      { title: "上海证券", domain: "shzq.com" },
      { title: "申银万国", domain: "swhysc.com" },
      { title: "太平洋证券", domain: "tpyzq.com" },
      { title: "淘股吧", domain: "taoguba.com.cn" },
      { title: "腾讯自选股", domain: "gu.qq.com" },
      { title: "天才股票网", domain: "11159.com" },
      { title: "天风证券", domain: "tfzq.com" },
      { title: "万和证券", domain: "wanhesec.com.cn" },
      { title: "万联证券", domain: "wlzq.cn" },
      { title: "五矿证券", domain: "wkzq.com.cn" },
      { title: "西部证券", domain: "west95582.com" },
      { title: "西南证券", domain: "swsc.com.cn" },
      { title: "香港信誠證券", domain: "pru.hk" },
      { title: "湘财证券", domain: "xcsc.com" },
      { title: "新时代证券", domain: "xsdzq.cn" },
      { title: "兴业证券", domain: "xyzq.com.cn" },
      { title: "银泰证券", domain: "ytzq.com" },
      { title: "赢家财富网", domain: "yingjia360.com" },
      { title: "长城证券", domain: "cgws.com" },
      { title: "长江证券", domain: "95579.com" },
      { title: "招商证券", domain: "cmschina.com" },
      { title: "浙商证券", domain: "stocke.com.cn" },
      { title: "正点财经", domain: "zdcj.net" },
      { title: "证券之星数据", domain: "resource.stockstar.com" },
      { title: "中国银河证券", domain: "chinastock.com.cn" },
      { title: "中泰证券", domain: "zts.com.cn" },
      { title: "中天证券", domain: "iztzq.com" },
      { title: "中信证券", domain: "citics.com" },
      { title: "中银证券", domain: "bocichina.com" },
      { title: "中邮证券", domain: "cnpsec.com.cn" },
      { title: "中原证券", domain: "ccnew.com" }
    ]
  },
  {
    category: "旅游网站",
    categoryI18nKey: "travel",
    sites: [
      { title: "春秋旅行社", domain: "springtour.com" },
      { title: "飞客茶馆", domain: "flyertea.com" },
      { title: "飞猪旅行", domain: "fliggy.com" },
      { title: "广之旅", domain: "gzl.com.cn" },
      { title: "国际青年旅舍", domain: "yhachina.com" },
      { title: "韩游网", domain: "hanyouwang.com" },
      { title: "锦江旅游", domain: "jjtravel.com" },
      { title: "凯撒旅游", domain: "caissa.com.cn" },
      { title: "驴妈妈旅游网", domain: "lvmama.com" },
      { title: "蚂蜂窝", domain: "mafengwo.cn" },
      { title: "猫途鹰", domain: "tripadvisor.cn" },
      { title: "米胖旅游网", domain: "mipang.com" },
      { title: "穷游网", domain: "qyer.com" },
      { title: "去哪儿旅行", domain: "qunar.com" },
      { title: "同程网", domain: "ly.com" },
      { title: "途风网", domain: "cn.toursforfun.com" },
      { title: "途牛旅游网", domain: "tuniu.com" },
      { title: "携程旅游网", domain: "ctrip.com" },
      { title: "欣欣旅游", domain: "cncn.com" },
      { title: "艺龙", domain: "elong.com" },
      { title: "悠哉旅游网", domain: "uzai.com" },
      { title: "游侠客", domain: "youxiake.com" },
      { title: "中青旅遨游网", domain: "aoyou.com" }
    ]
  },
  {
    category: "汽车网站",
    categoryI18nKey: "automotive",
    sites: [
      { title: "58汽车", domain: "58che.com" },
      { title: "爱卡汽车网", domain: "xcar.com.cn" },
      { title: "车300", domain: "che300.com" },
      { title: "车讯网", domain: "chexun.com" },
      { title: "车质网", domain: "12365auto.com" },
      { title: "车质网论坛", domain: "bbs.12365auto.com" },
      { title: "车主之家", domain: "16888.com" },
      { title: "第一车网", domain: "iautos.cn" },
      { title: "电动邦", domain: "diandong.com" },
      { title: "懂车帝", domain: "dongchedi.com" },
      { title: "二手车之家", domain: "che168.com" },
      { title: "房车之家", domain: "rv28.com" },
      { title: "盖世汽车网", domain: "auto.gasgoo.com" },
      { title: "瓜子二手车", domain: "guazi.com" },
      { title: "卡车之家", domain: "360che.com" },
      { title: "买车网", domain: "maiche.com" },
      { title: "农用车", domain: "chinacar.com.cn" },
      { title: "汽车之家", domain: "autohome.com.cn" },
      { title: "全球电动车网", domain: "qqddc.com" },
      { title: "搜狐汽车", domain: "auto.sohu.com" },
      { title: "太平洋汽车网", domain: "pcauto.com.cn" },
      { title: "淘车网", domain: "taoche.com" },
      { title: "腾讯汽车", domain: "auto.qq.com" },
      { title: "网上车市", domain: "cheshi.com" },
      { title: "网通社", domain: "news18a.com" },
      { title: "网易汽车", domain: "auto.163.com" },
      { title: "新车评网", domain: "xincheping.com" },
      { title: "新浪汽车", domain: "auto.sina.com.cn" },
      { title: "易车网", domain: "bitauto.com" },
      { title: "优酷汽车", domain: "auto.youku.com" },
      { title: "越野ｅ族", domain: "bbs.fblife.com" },
      { title: "中国电动车网", domain: "ddc.net.cn" },
      { title: "中国二手车城", domain: "cn2che.com" },
      { title: "中国汽车消费网", domain: "315che.com" }
    ]
  },
  {
    category: "社交网站",
    categoryI18nKey: "social",
    sites: [
      { title: "114结婚网", domain: "wed114.cn" },
      { title: "51同城交友", domain: "jiaoyou.51.com" },
      { title: "E部落", domain: "ecl.com.cn" },
      { title: "QQ空间", domain: "qzone.qq.com" },
      { title: "Soul", domain: "soulapp.cn" },
      { title: "Tagged", domain: "tagged.com" },
      { title: "VK", domain: "vk.com" },
      { title: "爱聊聊天室", domain: "loveliao.com" },
      { title: "爱屋交友", domain: "loveoo.com" },
      { title: "爱在这儿", domain: "loveinhere.com" },
      { title: "百合网", domain: "baihe.com" },
      { title: "到喜啦", domain: "daoxila.com" },
      { title: "等你网", domain: "dengni.org" },
      { title: "都市红娘", domain: "hongniang.com" },
      { title: "对面", domain: "duimian.cn" },
      { title: "飞赞", domain: "feizan.com" },
      { title: "福建交友网", domain: "fj987.com" },
      { title: "呱呱视频社区", domain: "17guagua.com" },
      { title: "河北酷儿", domain: "hbke.com" },
      { title: "花田", domain: "love.163.com" },
      { title: "婚礼纪", domain: "hunliji.com" },
      { title: "简爱网", domain: "jianai360.com" },
      { title: "简简单单", domain: "jjdd.com" },
      { title: "开心网", domain: "kaixin001.com" },
      { title: "拉拉聊天室", domain: "lalachat.15880.com" },
      { title: "兰草之恋", domain: "hunlian100.com" },
      { title: "浪漫网", domain: "chs.romantic214.com" },
      { title: "脸谱网", domain: "lianpupu.com" },
      { title: "恋爱记", domain: "lianaibiji.com" },
      { title: "两个人", domain: "liageren.com" },
      { title: "聊聊网", domain: "liaoliao.com" },
      { title: "玫瑰情人网", domain: "mgqr.com" },
      { title: "美好家园", domain: "wx920.com" },
      { title: "免费征婚网", domain: "freezhw.com" },
      { title: "陌路人", domain: "mlrcn.com" },
      { title: "陌陌", domain: "immomo.com" },
      { title: "派派官网", domain: "17paipai.cn" },
      { title: "青城之恋", domain: "nmglove.cn" },
      { title: "趣约会", domain: "marry5.com" },
      { title: "人人网", domain: "renren.com" },
      { title: "若爱网", domain: "ruoai.cn" },
      { title: "世纪佳缘", domain: "jiayuan.com" },
      { title: "速配网", domain: "supei.com" },
      { title: "探探", domain: "tantanapp.com" },
      { title: "腾讯通", domain: "rtx.tencent.com" },
      { title: "同城约会", domain: "yuehui.163.com" },
      { title: "玩吧", domain: "moqiwanba.com" },
      { title: "微会", domain: "weihuitel.com" },
      { title: "微信网页版", domain: "web.weixin.qq.com" },
      { title: "微信网页版登录", domain: "login.weixin.qq.com" },
      { title: "维情网", domain: "weiqing120.com" },
      { title: "未名交友", domain: "jiaoyou8.com" },
      { title: "我主良缘", domain: "7799520.com" },
      { title: "小恩爱", domain: "xiaoenai.com" },
      { title: "新浪SHOW", domain: "sinashow.com" },
      { title: "绣球缘", domain: "xiuqiuy.com" },
      { title: "徐州征婚网", domain: "xzzh.com" },
      { title: "一线姻缘", domain: "11yinyuan.com" },
      { title: "有缘网", domain: "youyuan.com" },
      { title: "雨后池塘", domain: "yuhou.com" },
      { title: "语玩", domain: "52yuwan.com" },
      { title: "缘来网", domain: "yuanlai.com" },
      { title: "珍爱网", domain: "zhenai.com" },
      { title: "真情在线", domain: "lol99.com" },
      { title: "知音", domain: "zhiyin.cn" },
      { title: "中国婚博会", domain: "jiehun.com.cn" },
      { title: "中老年征婚再婚网", domain: "751314.com" },
      { title: "重庆购物狂情感交友", domain: "love.cqmmgo.com" },
      { title: "钻石婚恋网", domain: "zuanshi.com" }
    ]
  },
  {
    category: "视频网站",
    categoryI18nKey: "video",
    sites: [
      { title: "2345影视", domain: "kan.2345.com" },
      { title: "360影视", domain: "360kan.com" },
      { title: "56网", domain: "56.com" },
      { title: "9158直播", domain: "9158.com" },
      { title: "AcFun", domain: "acfun.cn" },
      { title: "CCTV官网", domain: "tv.cctv.com" },
      { title: "CC直播", domain: "cc.163.com" },
      { title: "Hao123影视", domain: "v.hao123.baidu.com" },
      { title: "PP视频", domain: "pptv.com" },
      { title: "YY直播", domain: "yy.com" },
      { title: "爱奇艺", domain: "iqiyi.com" },
      { title: "安徽电视台", domain: "ahtv.cn" },
      { title: "百度视频", domain: "v.xiaodutv.com" },
      { title: "北京电视台", domain: "brtn.cn" },
      { title: "哔哩哔哩", domain: "bilibili.com" },
      { title: "电视牛", domain: "tvniu.com" },
      { title: "电视直播网", domain: "hao5.net" },
      { title: "抖音", domain: "douyin.com" },
      { title: "斗鱼直播", domain: "douyutv.com" },
      { title: "风行", domain: "fun.tv" },
      { title: "凤凰视频", domain: "v.ifeng.com" },
      { title: "广东电视台", domain: "gdtv.cn" },
      { title: "好看视频", domain: "haokan.baidu.com" },
      { title: "好趣网", domain: "haoqu.net" },
      { title: "虎牙直播", domain: "huya.com" },
      { title: "花椒直播", domain: "huajiao.com" },
      { title: "华数TV", domain: "wasu.cn" },
      { title: "江苏卫视", domain: "jstv.com" },
      { title: "江西卫视", domain: "jxtv.jxntv.cn" },
      { title: "九秀直播", domain: "9xiu.com" },
      { title: "酷狗直播", domain: "fanxing.kugou.com" },
      { title: "快手", domain: "kuaishou.com" },
      { title: "乐视网", domain: "le.com" },
      { title: "梨视频", domain: "pearvideo.com" },
      { title: "芒果TV", domain: "mgtv.com" },
      { title: "芒果TV直播", domain: "live.mgtv.com" },
      { title: "咪咕视频", domain: "miguvideo.com" },
      { title: "企鹅直播", domain: "live.qq.com" },
      { title: "山东电视台", domain: "v.iqilu.com" },
      { title: "硕鼠视频", domain: "flvcd.com" },
      { title: "搜狐视频", domain: "tv.sohu.com" },
      { title: "搜库", domain: "soku.com" },
      { title: "腾讯视频", domain: "v.qq.com" },
      { title: "土豆网", domain: "tudou.com" },
      { title: "我秀直播", domain: "woxiu.com" },
      { title: "西瓜视频", domain: "ixigua.com" },
      { title: "香港TVB", domain: "tvb.com" },
      { title: "新浪视频", domain: "video.sina.com.cn" },
      { title: "央视网", domain: "v.cctv.com" },
      { title: "一直播", domain: "yizhibo.com" },
      { title: "易视直播", domain: "cietv.com" },
      { title: "优酷网", domain: "youku.com" },
      { title: "浙江卫视", domain: "zjstv.com" }
    ]
  },
  {
    category: "体育网站",
    categoryI18nKey: "sports",
    sites: [
      { title: "7m体育网", domain: "7m.com.cn" },
      { title: "CBA赛事", domain: "cbaleague.com" },
      { title: "NBA中国", domain: "china.nba.com" },
      { title: "PPTV体育", domain: "sports.pptv.com" },
      { title: "爱奇艺体育", domain: "sports.iqiyi.com" },
      { title: "东方体育", domain: "sports.eastday.com" },
      { title: "懂球帝", domain: "dongqiudi.com" },
      { title: "虎扑CBA", domain: "cba.hupu.com" },
      { title: "虎扑NBA", domain: "nba.hupu.com" },
      { title: "虎扑体育", domain: "hupu.com" },
      { title: "虎扑足球", domain: "soccer.hupu.com" },
      { title: "华体网", domain: "sportscn.com" },
      { title: "欢呼吧", domain: "huanhuba.com" },
      { title: "即时比分", domain: "live.500.com" },
      { title: "雷速体育", domain: "leisu.com" },
      { title: "搜狐体育", domain: "sports.sohu.com" },
      { title: "腾讯体育", domain: "sports.qq.com" },
      { title: "体赛", domain: "qzcdsm.cn" },
      { title: "体坛周报", domain: "titan24.com" },
      { title: "网易体育", domain: "sports.163.com" },
      { title: "唯彩看球", domain: "vipc.cn" },
      { title: "新华体育", domain: "sports.xinhuanet.com" },
      { title: "新浪体育", domain: "sports.sina.com.cn" },
      { title: "新浪体育视频", domain: "sports.video.sina.com.cn" },
      { title: "央视体育", domain: "sports.cctv.com" },
      { title: "直播TV", domain: "zhibo.tv" },
      { title: "直播吧", domain: "zhibo8.cc" },
      { title: "直播吧", domain: "zhibo8.com" },
      { title: "中国篮协", domain: "cba.net.cn" },
      { title: "抓饭直播", domain: "zhuafan.tech" },
      { title: "足球吧", domain: "soccerbar.cc" }
    ]
  },
  {
    category: "网购网站",
    categoryI18nKey: "ecommerce",
    sites: [
      { title: "55海淘网", domain: "55haitao.com" },
      { title: "阿里巴巴", domain: "1688.com" },
      { title: "爱淘宝", domain: "ai.taobao.com" },
      { title: "博库网", domain: "bookuu.com" },
      { title: "当当网", domain: "dangdang.com" },
      { title: "返利网", domain: "51fanli.com" },
      { title: "京东商城", domain: "jd.com" },
      { title: "京喜", domain: "jingxi.com" },
      { title: "九机网", domain: "9ji.com" },
      { title: "卖家网", domain: "maijia.com" },
      { title: "慢慢买", domain: "manmanbuy.com" },
      { title: "蘑菇街", domain: "mogu.com" },
      { title: "拼多多", domain: "youhui.pinduoduo.com" },
      { title: "识货", domain: "shihuo.cn" },
      { title: "搜款网", domain: "vvic.com" },
      { title: "苏宁易购", domain: "suning.com" },
      { title: "淘宝网", domain: "taobao.com" },
      { title: "天猫精选", domain: "s.click.taobao.com" },
      { title: "土猫网", domain: "toolmall.com" },
      { title: "网易严选", domain: "you.163.com" },
      { title: "唯品会", domain: "click.union.vip.com" },
      { title: "西域", domain: "ehsy.com" },
      { title: "闲鱼", domain: "2.taobao.com" },
      { title: "小米有品", domain: "xiaomiyoupin.com" },
      { title: "亚马逊", domain: "amazon.cn" },
      { title: "一起做网店", domain: "17zwd.com" },
      { title: "一淘网", domain: "etao.com" },
      { title: "有货网", domain: "yohobuy.com" },
      { title: "有路网", domain: "youlu.net" },
      { title: "杂志铺", domain: "zazhipu.com" }
    ]
  },
  {
    category: "网盘网站",
    categoryI18nKey: "cloudStorage",
    sites: [
      { title: "115网盘", domain: "115.com" },
      { title: "360云盘", domain: "yunpan.360.cn" },
      { title: "iCloud", domain: "icloud.com.cn" },
      { title: "OneDrive", domain: "skydrive.live.com" },
      { title: "阿里云盘", domain: "aliyundrive.com" },
      { title: "百度网盘", domain: "pan.baidu.com" },
      { title: "城通网盘", domain: "ctfile.com" },
      { title: "免费空间", domain: "free.3v.do" },
      { title: "腾讯微云", domain: "weiyun.com" },
      { title: "天翼云", domain: "cloud.189.cn" },
      { title: "微盘", domain: "vdisk.weibo.com" },
      { title: "中国移动云盘", domain: "yun.139.com" }
    ]
  },
  {
    category: "下载站网站",
    categoryI18nKey: "downloadSite",
    sites: [
      { title: "1001下载乐园", domain: "sz1001.net" },
      { title: "2345软件大全", domain: "duote.com" },
      { title: "360软件宝库", domain: "baoku.360.cn" },
      { title: "3DMGAME下载站", domain: "dl.3dmgame.com" },
      { title: "5577我机网", domain: "5577.com" },
      { title: "711软件站", domain: "soft711.com" },
      { title: "91下载", domain: "91xiazai.com" },
      { title: "9553绿色软件站", domain: "9553.com" },
      { title: "hao123下载站", domain: "soft.hao123.com" },
      { title: "hao123下载站", domain: "skycn.net" },
      { title: "JZ5U绿色下载站", domain: "jz5u.com" },
      { title: "PC6下载站", domain: "pc6.com" },
      { title: "pc软件下载站", domain: "pc141.com" },
      { title: "ROM之家官网", domain: "romzhijia.net" },
      { title: "Win7系统之家", domain: "winwin7.com" },
      { title: "win7之家", domain: "win7zhijia.cn" },
      { title: "ZOL手机软件", domain: "sj.zol.com.cn" },
      { title: "安卓市场", domain: "topber.com" },
      { title: "百度手机助手", domain: "shouji.baidu.com" },
      { title: "百度应用", domain: "as.baidu.com" },
      { title: "比克尔下载", domain: "bkill.com" },
      { title: "创e下载园", domain: "7edown.com" },
      { title: "当贝市场", domain: "dangbei.com" },
      { title: "当客软件园", domain: "downkr.com" },
      { title: "当快软件园", domain: "downkuai.com" },
      { title: "当下软件园", domain: "downxia.com" },
      { title: "当易网", domain: "downyi.com" },
      { title: "电脑之家下载中心", domain: "download.pchome.net" },
      { title: "东东软件园", domain: "esoyu.com" },
      { title: "东坡下载", domain: "uzzf.com" },
      { title: "多多软件站", domain: "ddooo.com" },
      { title: "飞翔下载", domain: "52z.com" },
      { title: "非凡软件站", domain: "crsky.com" },
      { title: "咕咕猪下载站", domain: "guguzhu.com" },
      { title: "好特网", domain: "haote.com" },
      { title: "河东软件园", domain: "pc0359.cn" },
      { title: "红软基地", domain: "rsdown.cn" },
      { title: "华军软件园", domain: "onlinedown.net" },
      { title: "精品绿色便携软件", domain: "portablesoft.org" },
      { title: "历趣", domain: "liqucn.com" },
      { title: "绿软下载", domain: "itmop.com" },
      { title: "绿色软件", domain: "greenxf.com" },
      { title: "绿色软件家园", domain: "downg.com" },
      { title: "绿色软件联盟", domain: "xdowns.com" },
      { title: "绿色下载站", domain: "greenxiazai.com" },
      { title: "绿色资源网", domain: "downcc.com" },
      { title: "木蚂蚁绿色软件园", domain: "soft.mumayi.net" },
      { title: "七度苹果网", domain: "7do.net" },
      { title: "七喜下载站", domain: "7xdown.com" },
      { title: "起点软件园", domain: "cncrk.com" },
      { title: "软吧手机软件", domain: "ruan8.com" },
      { title: "闪电软件园", domain: "sd173.com" },
      { title: "搜狗软件下载", domain: "xiazai.sogou.com" },
      { title: "太平洋软件下载中心", domain: "dl.pconline.com.cn" },
      { title: "太平洋下载网", domain: "pcsoft.com.cn" },
      { title: "腾牛网", domain: "qqtn.com" },
      { title: "腾讯软件中心", domain: "pc.qq.com" },
      { title: "天极下载", domain: "mydown.yesky.com" },
      { title: "天空下载", domain: "skycn.com" },
      { title: "完美天空", domain: "wmzhe.com" },
      { title: "网侠手机站", domain: "hackhome.com" },
      { title: "未来软件园", domain: "orsoon.com" },
      { title: "西西软件园", domain: "cr173.com" },
      { title: "系统城", domain: "xitongcheng.com" },
      { title: "系统之家官网", domain: "xp85.com" },
      { title: "系统之家官网", domain: "xt700.com" },
      { title: "下载吧", domain: "xiazaiba.com" },
      { title: "下载王", domain: "xzking.com" },
      { title: "下载之家", domain: "downza.cn" },
      { title: "下载之家", domain: "xiazaizhijia.com" },
      { title: "小程序商店", domain: "91ud.com" },
      { title: "小米应用商店", domain: "app.mi.com" },
      { title: "小众软件", domain: "appinn.com" },
      { title: "心愿下载", domain: "wishdown.com" },
      { title: "星星软件站", domain: "cnd8.com" },
      { title: "异次元软件", domain: "iplaysoft.com" },
      { title: "应用宝", domain: "myapp.com" },
      { title: "应用宝官网", domain: "sj.qq.com" },
      { title: "应用汇", domain: "appchina.com" },
      { title: "游侠网下载站", domain: "down.ali213.net" },
      { title: "游侠下载站", domain: "youxiaxiazai.com" },
      { title: "中关村下载", domain: "xiazai.zol.com.cn" },
      { title: "最笨软件下载站", domain: "zuiben.com" }
    ]
  },
  {
    category: "小说网站",
    categoryI18nKey: "novel",
    sites: [
      { title: "456听书网", domain: "ting456.com" },
      { title: "有声吧", domain: "yousheng8.com" },
      { title: "01听书网", domain: "01tingshu.com" },
      { title: "136书屋", domain: "136book.com" },
      { title: "16K小说网", domain: "16kbook.org" },
      { title: "17K女生网", domain: "mm.17k.com" },
      { title: "17k小说网", domain: "17k.com" },
      { title: "24K中文网", domain: "24kzw.com" },
      { title: "30小说", domain: "30xiaoshuo.com" },
      { title: "4020电子书", domain: "4020.la" },
      { title: "55小说网", domain: "55xs.com" },
      { title: "58小说网", domain: "58xs.com" },
      { title: "69中文网", domain: "69zw.com" },
      { title: "86手机电子书", domain: "248268.com" },
      { title: "88106小说阅读网", domain: "88106.com" },
      { title: "E品中文小说", domain: "epzwxs.com" },
      { title: "QQ读书", domain: "ebook.qq.com" },
      { title: "QQ说说乐园", domain: "qqssly.com" },
      { title: "SF轻小说", domain: "book.sfacg.com" },
      { title: "SoDu迷", domain: "sodu.me" },
      { title: "SoDu小说搜索", domain: "sodu.tw" },
      { title: "Sodu小说搜索", domain: "7sodu.net" },
      { title: "TXT小说下载网", domain: "sjtxt.com" },
      { title: "TXT小说下载网站", domain: "txtbook.com.cn" },
      { title: "哎呦文学网", domain: "auwxw.com" },
      { title: "爱看小说网", domain: "aikann.com" },
      { title: "爱奇小说网", domain: "i7txt.net" },
      { title: "爱去小说网", domain: "aiquxs.com" },
      { title: "爱尚小说网", domain: "23hh.la" },
      { title: "爱小说", domain: "ixs.cc" },
      { title: "暗夜文学网", domain: "anyew.cn" },
      { title: "八一中文网", domain: "81zw.com" },
      { title: "八月居", domain: "bayueju.com" },
      { title: "白鹿书院", domain: "oklink.net" },
      { title: "半壁江中文网", domain: "banbijiang.com" },
      { title: "抱书吧", domain: "baoshu8.com" },
      { title: "北斗星小说网", domain: "beidouxin.com" },
      { title: "笔趣阁", domain: "biquge001.com" },
      { title: "笔趣阁", domain: "biquge.la" },
      { title: "笔趣库小说网", domain: "biquku.com" },
      { title: "菠萝小说", domain: "blnovel.com" },
      { title: "畅听网", domain: "ting85.com" },
      { title: "畅想听吧", domain: "cxt8.com" },
      { title: "超级兵王", domain: "chaojibingwang.net" },
      { title: "超星读书", domain: "book.chaoxing.com" },
      { title: "辰贼网", domain: "chenzei.com" },
      { title: "创世中文网", domain: "chuangshi.qq.com" },
      { title: "大风车小说网", domain: "dfcxs.com" },
      { title: "大众小说网", domain: "dzxsw.net" },
      { title: "顶点小说", domain: "23us.la" },
      { title: "动听free听书网", domain: "tingfree.com" },
      { title: "斗罗小说网", domain: "86696.cc" },
      { title: "斗破苍穹小说网", domain: "doupocangqiong1.com" },
      { title: "短文学网", domain: "duanwenxue.com" },
      { title: "段子网", domain: "ishuo.cn" },
      { title: "二层楼书院", domain: "2cloo.com" },
      { title: "二月天", domain: "2yt.net" },
      { title: "飞卢女生网", domain: "mm.faloo.com" },
      { title: "飞卢同人小说网", domain: "tongren.faloo.com" },
      { title: "飞卢小说网精选小说", domain: "haokan.faloo.com" },
      { title: "飞卢中文网", domain: "faloo.com" },
      { title: "粉色书城", domain: "fensebook.com" },
      { title: "凤凰读书", domain: "book.ifeng.com" },
      { title: "腹黑书小说阅读网", domain: "fuheishu.com" },
      { title: "古典文学网", domain: "gudianwenxue.com" },
      { title: "古龙武侠网", domain: "gulongbbs.com" },
      { title: "官术网", domain: "3dllc.com" },
      { title: "鬼吹灯全集在线阅读", domain: "cxbz958.com" },
      { title: "鬼故事", domain: "guidaye.com" },
      { title: "好读", domain: "haodoo.net" },
      { title: "黑岩网", domain: "heiyan.com" },
      { title: "红薯中文网", domain: "hongshu.com" },
      { title: "红袖添香", domain: "hongxiu.com" },
      { title: "花雨言情小说", domain: "inbook.net" },
      { title: "话本小说网", domain: "ihuaben.com" },
      { title: "幻听网", domain: "ting89.com" },
      { title: "晋江文学城", domain: "jjwxc.net" },
      { title: "晋江文学城", domain: "my.jjwxc.net" },
      { title: "精彩东方文学", domain: "jcdf99.com" },
      { title: "精品书城", domain: "jingpinshucheng.com" },
      { title: "九象网", domain: "9xwang.com" },
      { title: "九悦小说", domain: "fanwai.19lou.com" },
      { title: "久久小说吧", domain: "9191net.com" },
      { title: "久久小说下载网", domain: "txt99.org" },
      { title: "橘园小说社区", domain: "bbs.jooyoo.net" },
      { title: "看啦又看小说网", domain: "k6uk.com" },
      { title: "看书吧", domain: "kanshu8.net" },
      { title: "酷匠网", domain: "kujiang.com" },
      { title: "快读", domain: "kuaidu.com.cn" },
      { title: "拉牛牛小说网", domain: "la66.com" },
      { title: "懒人听书", domain: "lrts.me" },
      { title: "老约翰绘本馆", domain: "hui-ben.com" },
      { title: "乐读窝", domain: "leduwo.com" },
      { title: "猎人小说网", domain: "orion34g.com" },
      { title: "凌云文学网", domain: "lingyun5.com" },
      { title: "零点看书", domain: "lingdiankanshu.com" },
      { title: "龙的天空", domain: "lkong.net" },
      { title: "龙坛书网", domain: "longtanshuw.com" },
      { title: "满庭芳言情小说吧", domain: "mtfcn.com" },
      { title: "茅山后裔", domain: "maoshanhouyi.guidaye.com" },
      { title: "美文网", domain: "lookmw.cn" },
      { title: "美文阅读网", domain: "meiwen.com.cn" },
      { title: "妙笔阁", domain: "miaobige.com" },
      { title: "名著小说网", domain: "mingzhuxiaoshuo.com" },
      { title: "名著阅读网", domain: "mzhu8.com" },
      { title: "明朝那些事儿", domain: "mingchaonaxieshier.com" },
      { title: "磨铁中文网", domain: "motie.com" },
      { title: "墨坛文学", domain: "114zw.com" },
      { title: "墨坛文学", domain: "yjxs.net" },
      { title: "墨斋小说网", domain: "qsxiaoshuo.com" },
      { title: "派派小说后花园", domain: "paipai.fm" },
      { title: "品味吧", domain: "feel-bar.com" },
      { title: "七猫中文网", domain: "qimao.com" },
      { title: "奇热小说网", domain: "qirebook.com" },
      { title: "奇书小说网", domain: "qibookw.com" },
      { title: "起点女生网", domain: "qdmm.com" },
      { title: "起点文学网", domain: "qdwenxue.com" },
      { title: "起点中文网", domain: "qidian.com" },
      { title: "千千小说网", domain: "qqtxt.cc" },
      { title: "琴帝小说网", domain: "qindi.net" },
      { title: "请看吧小说网", domain: "qingkan8.com" },
      { title: "燃文小说", domain: "ranwen.com" },
      { title: "燃文小说网", domain: "ranwen.org" },
      { title: "燃文小说网", domain: "52ranwen.net" },
      { title: "燃文小说网", domain: "ranwen.net" },
      { title: "人生屋", domain: "rensheng5.com" },
      { title: "榕树下", domain: "rongshuxia.com" },
      { title: "若初文学网", domain: "ruochu.com" },
      { title: "若雨中文网", domain: "3yt.com" },
      { title: "三国在线", domain: "e3ol.com" },
      { title: "散文吧", domain: "sanwen8.cn" },
      { title: "山西小说网", domain: "sxtvi.com" },
      { title: "神马小说网", domain: "shenmaxiaoshuo.com" },
      { title: "世界名著网", domain: "t.icesmall.cn" },
      { title: "书包网", domain: "bookbao.me" },
      { title: "书法迷", domain: "shufami.com" },
      { title: "书阁网", domain: "bookgew.com" },
      { title: "书海文学网", domain: "wenxue.shuhai.com" },
      { title: "书海言情小说网", domain: "mm.shuhai.com" },
      { title: "书荒啦文学网", domain: "shuhuang.la" },
      { title: "书连小说网", domain: "vip.shulink.com" },
      { title: "书迷楼", domain: "shumilou.com" },
      { title: "书旗网", domain: "shuqi.com" },
      { title: "书旗小说", domain: "aliwx.com.cn" },
      { title: "舒阅网", domain: "shuyue.cc" },
      { title: "思路客小说网", domain: "siluke.cc" },
      { title: "思路客小说阅读网", domain: "silukee.com" },
      { title: "四库书", domain: "sikushu.com" },
      { title: "搜狗小说", domain: "novel.wap.soso.com" },
      { title: "塔读文学网", domain: "tadu.com" },
      { title: "腾讯读书", domain: "book.qq.com" },
      { title: "天地中文网", domain: "tiandizw.com" },
      { title: "天方听书网", domain: "tingbook.com" },
      { title: "天天评书网", domain: "pingshu365.com" },
      { title: "天天中文", domain: "ttzw.com" },
      { title: "天下书盟网", domain: "fbook.net" },
      { title: "天涯文学", domain: "ebook.tianya.cn" },
      { title: "甜悦读网", domain: "sweetread.net" },
      { title: "听东方", domain: "tingdongfang.com" },
      { title: "听书阁", domain: "tingshuge.com" },
      { title: "吞噬小说网", domain: "tsxsw.com" },
      { title: "完本小说网", domain: "wanbenxiaoshuo.net" },
      { title: "完本小说下载网", domain: "wanbenxs.com" },
      { title: "晚安小说下载网", domain: "wanantxt.com" },
      { title: "万卷吧", domain: "wanjuanba.com" },
      { title: "万卷书屋", domain: "wjsw.com" },
      { title: "网易云阅读", domain: "yuedu.163.com" },
      { title: "文章阅读网", domain: "duwenzhang.com" },
      { title: "我爱读电子书", domain: "woaidu.org" },
      { title: "无错小说网", domain: "wcxsw.com" },
      { title: "武侠小说网", domain: "wuxia.name" },
      { title: "香网", domain: "xiang5.com" },
      { title: "逍遥小说网", domain: "xoyo100.com" },
      { title: "潇湘书院", domain: "xxsy.net" },
      { title: "小说村", domain: "xscun.com" },
      { title: "小说书网", domain: "xiaoshuoshu.org" },
      { title: "小说网", domain: "xstxt.com" },
      { title: "小说阅读网", domain: "readnovel.com" },
      { title: "小说阅读网", domain: "bookba.net" },
      { title: "小说阅读网", domain: "xs.cn" },
      { title: "校园堂", domain: "xiaoyuantang.com" },
      { title: "新笔下文学", domain: "bxwx.cc" },
      { title: "新快眼看书", domain: "booksky.so" },
      { title: "新浪读书", domain: "book.sina.com.cn" },
      { title: "星月书吧", domain: "xyshu8.com" },
      { title: "星云搜盟", domain: "bookcu.com" },
      { title: "炫书网", domain: "3uww.com" },
      { title: "雅文言情小说吧", domain: "yawen8.com" },
      { title: "言情吧", domain: "yanqingba.cn" },
      { title: "言情库", domain: "yqk.net" },
      { title: "言情小说", domain: "yanqing.readnovel.com" },
      { title: "言情小说吧", domain: "mm.txtbook.com.cn" },
      { title: "言情小说网", domain: "love.kanunu8.com" },
      { title: "雁北堂中文网", domain: "ebtang.com" },
      { title: "要看书网", domain: "1kanshu.cc" },
      { title: "一千零一页小说网", domain: "1001p.com" },
      { title: "宜搜小说", domain: "book.easou.com" },
      { title: "倚栏轩文学网", domain: "elanp.com" },
      { title: "英文小说网", domain: "novel.tingroom.com" },
      { title: "有声天下听书网", domain: "mysye.com" },
      { title: "雨枫轩", domain: "rain8.com" },
      { title: "雨露文章网", domain: "vipyl.com" },
      { title: "云起书院", domain: "yunqi.qq.com" },
      { title: "云起书院", domain: "yc.qq.com" },
      { title: "长江中文网", domain: "cjzww.com" },
      { title: "掌阅小说网", domain: "yc.ireader.com.cn" },
      { title: "中文听书网", domain: "tingzh.com" },
      { title: "终点网", domain: "guaili.org" },
      { title: "逐浪小说", domain: "book.zhulang.com" },
      { title: "追书神器", domain: "zhuishushenqi.com" },
      { title: "追书网", domain: "zhuishu.com" },
      { title: "总裁的替身前妻", domain: "zongcaidetishenqianqi.net" },
      { title: "纵横中文网", domain: "zongheng.com" },
      { title: "最爱小说网", domain: "zaxsw.org" },
      { title: "醉书楼", domain: "zuishulou.com" },
      { title: "作客文学网", domain: "zuok.com.cn" }
    ]
  },
  {
    category: "新闻网站",
    categoryI18nKey: "news",
    sites: [
      { title: "CCTV新闻", domain: "news.cntv.cn" },
      { title: "TOM网", domain: "tom.com" },
      { title: "ZAKER新闻", domain: "myzaker.com" },
      { title: "安徽日报", domain: "epaper.anhuinews.com" },
      { title: "奥一网", domain: "oeeee.com" },
      { title: "百度新闻", domain: "news.baidu.com" },
      { title: "半岛晨报", domain: "ep.bdcb.cn" },
      { title: "半岛都市报", domain: "bddsb.bandao.cn" },
      { title: "半月谈", domain: "banyuetan.org" },
      { title: "宝安日报", domain: "barb.sznews.com" },
      { title: "宝鸡日报", domain: "bjrb.joyhua.cn" },
      { title: "北方法制报", domain: "dz.bffzb.com" },
      { title: "北方新报", domain: "szb.northnews.cn" },
      { title: "北方周末报", domain: "commend.nmgnews.com.cn" },
      { title: "北京日报", domain: "bjrbdzb.bjd.com.cn" },
      { title: "北青网", domain: "ynet.com" },
      { title: "滨海时报", domain: "bhsb.tjbhnews.com" },
      { title: "参考消息", domain: "cankaoxiaoxi.com" },
      { title: "常德晚报", domain: "cdwb.cdyee.com" },
      { title: "成都日报", domain: "cdrb.com.cn" },
      { title: "成都商报", domain: "e.chengdu.cn" },
      { title: "承德日报", domain: "paper.hehechengde.cn" },
      { title: "池州日报", domain: "chiznews.com" },
      { title: "赤峰日报", domain: "cfrb.cn" },
      { title: "滁州日报", domain: "szbk.chuzhou.cn" },
      { title: "楚天都市报", domain: "ctdsb.cnhubei.com" },
      { title: "触电新闻", domain: "itouchtv.cn" },
      { title: "春城晚报", domain: "ccwb.yunnan.cn" },
      { title: "大公报", domain: "takungpao.com" },
      { title: "大河报", domain: "dahe.cn" },
      { title: "大连日报", domain: "szb.dlxww.com" },
      { title: "大庆日报", domain: "dqdaily.com" },
      { title: "大同日报", domain: "epaper.dtnews.cn" },
      { title: "大兴安岭日报", domain: "paper.dxalrb.org.cn" },
      { title: "大众日报", domain: "paper.dzcom" },
      { title: "当代生活报", domain: "epaper.gxrb.com.cn" },
      { title: "东方今报", domain: "jinbw.com.cn" },
      { title: "东方卫报", domain: "dfwb.njnews.cn" },
      { title: "东方资讯", domain: "mini.eastday.com" },
      { title: "东莞时报", domain: "dgtimes.timedg.com" },
      { title: "东南早报", domain: "szb.qzwb.com" },
      { title: "东台日报", domain: "digital.dtxww.com" },
      { title: "都市晨报", domain: "epaper.cnxz.com.cn" },
      { title: "都市时报", domain: "times.clzg.cn" },
      { title: "恩施晚报", domain: "szb.enshi.cn" },
      { title: "法制日报", domain: "legaldaily.com.cn" },
      { title: "番禹日报", domain: "pyrb.dayoo.com" },
      { title: "凤凰资讯", domain: "news.ifeng.com" },
      { title: "福建东南新闻网", domain: "fjsen.com" },
      { title: "福建日报", domain: "fjrb.fjsen.com" },
      { title: "福州晚报", domain: "mag.fznews.com.cn" },
      { title: "甘肃日报", domain: "szb.gansudaily.com.cn" },
      { title: "光明日报", domain: "epaper.gmw.cn" },
      { title: "光明网", domain: "gmw.cn" },
      { title: "广东科技报", domain: "gdkjb.com" },
      { title: "广西日报", domain: "gxrb.gxnews.com.cn" },
      { title: "广西新闻网", domain: "gxnews.com.cn" },
      { title: "广州日报", domain: "gzdaily.dayoo.com" },
      { title: "贵州日报", domain: "szb.gzrbs.com.cn" },
      { title: "国际在线", domain: "cri.cn" },
      { title: "哈尔滨日报", domain: "hb.my399.com" },
      { title: "海口晚报", domain: "szb.hkwb.net" },
      { title: "海南日报", domain: "hnrb.hinews.cn" },
      { title: "海外网", domain: "haiwainet.cn" },
      { title: "海峡导报", domain: "epaper.taihainet.com" },
      { title: "海峡都市报", domain: "hxnews.com" },
      { title: "杭州日报", domain: "hzdaily.hangzhou.com.cn" },
      { title: "合肥日报", domain: "newspaper.hf365.com" },
      { title: "河北工人报", domain: "hbgrb.net" },
      { title: "河北日报", domain: "hbrb.hebnews.cn" },
      { title: "黑龙江东北网", domain: "dbw.cn" },
      { title: "湖北日报", domain: "hbrb.cnhubei.com" },
      { title: "湖南日报", domain: "epaper.voc.com.cn" },
      { title: "华商网", domain: "hsw.cn" },
      { title: "华西都市报", domain: "wccdaily.com.cn" },
      { title: "华夏时报", domain: "chinatimes.net.cn" },
      { title: "淮安日报", domain: "szb.hynews.net" },
      { title: "环球网", domain: "huanqiu.com" },
      { title: "惠州日报", domain: "e.hznews.com" },
      { title: "吉林日报", domain: "jlrbszb.cnjiwang.com" },
      { title: "济南日报", domain: "jnrb.e23.cn" },
      { title: "济南时报", domain: "jinantimes.com.cn" },
      { title: "嘉兴日报", domain: "jxrb.cnjxol.com" },
      { title: "江城日报", domain: "szb.shjnet.cn" },
      { title: "江南都市报", domain: "jxnews.com.cn" },
      { title: "江苏商报", domain: "jssb.njnews.cn" },
      { title: "江西日报", domain: "jiangxi.jxnews.com.cn" },
      { title: "解放军报", domain: "chinamil.com.cn" },
      { title: "解放日报", domain: "jfdaily.com" },
      { title: "界面新闻", domain: "jiemian.com" },
      { title: "今日头条", domain: "toutiao.com" },
      { title: "今日早报", domain: "jrzb.zjol.com.cn" },
      { title: "今晚报", domain: "epaper.jwb.com.cn" },
      { title: "金陵晚报", domain: "jlwb.njnews.cn" },
      { title: "经济参考报", domain: "dz.jjckb.cn" },
      { title: "经济日报", domain: "paper.ce.cn" },
      { title: "晶报", domain: "jb.sznews.com" },
      { title: "看看新闻网", domain: "kankanews.com" },
      { title: "快资讯", domain: "360kuai.com" },
      { title: "拉萨日报", domain: "lasa-eveningnews.com.cn" },
      { title: "拉萨晚报", domain: "lasaribao.com" },
      { title: "兰州晨报", domain: "lzcbnews.com" },
      { title: "兰州新闻网", domain: "lzbs.com.cn" },
      { title: "联合早报", domain: "zaobao.com" },
      { title: "辽宁北国网", domain: "lnd.com.cn" },
      { title: "辽宁日报", domain: "epaper.lnd.com.cn" },
      { title: "辽源日报", domain: "read.0437.com" },
      { title: "洛阳日报", domain: "lyrb.lyd.com.cn" },
      { title: "洛阳晚报", domain: "lywb.lyd.com.cn" },
      { title: "眉山日报", domain: "szb.mshw.net" },
      { title: "梅州日报", domain: "mzrb.meizhou.cn" },
      { title: "每日甘肃", domain: "gansudaily.com.cn" },
      { title: "每日经济新闻", domain: "mrjjxw.com" },
      { title: "每日新报", domain: "epaper.tianjinwe.com" },
      { title: "绵阳晚报", domain: "wbepaper.myrb.net" },
      { title: "南方都市报", domain: "epaper.oeeee.com" },
      { title: "南方日报", domain: "epaper.southcn.com" },
      { title: "南方网", domain: "southcn.com" },
      { title: "南方周末", domain: "infzm.com" },
      { title: "南风窗", domain: "nfcmag.com" },
      { title: "南国都市报", domain: "ngdsb.hinews.cn" },
      { title: "南国早报", domain: "ngzb.gxrb.com.cn" },
      { title: "南湖晚报", domain: "nhwb.cnjxol.com" },
      { title: "南华早报", domain: "scmpchinese.com" },
      { title: "南京晨报", domain: "njcb.xhby.net" },
      { title: "南京日报", domain: "njrb.njdaily.cn" },
      { title: "南通日报", domain: "epaper.ntrb.com.cn" },
      { title: "南阳日报", domain: "epaper.01ny.cn" },
      { title: "内蒙古晨报", domain: "nmgcb.com.cn" },
      { title: "内蒙古法制报", domain: "nmgfzb.cn" },
      { title: "宁波日报", domain: "daily.cnnb.com.cn" },
      { title: "宁夏电视台", domain: "nxtv.com.cn" },
      { title: "宁夏日报", domain: "nxnews.net" },
      { title: "澎湃新闻", domain: "thepaper.cn" },
      { title: "齐鲁晚报", domain: "epaper.qlwb.com.cn" },
      { title: "千龙网", domain: "news.qianlong.com" },
      { title: "千山晚报", domain: "qianhuaweb.com" },
      { title: "钱江晚报", domain: "zjdaily.com.cn" },
      { title: "黔西南日报", domain: "qxnrb.com" },
      { title: "青海新闻网", domain: "qhnews.com" },
      { title: "清远日报", domain: "epaper.qyrb.com:7777" },
      { title: "求是", domain: "qstheory.cn" },
      { title: "人民日报", domain: "paper.people.com.cn" },
      { title: "人民网", domain: "people.com.cn" },
      { title: "三秦都市报", domain: "epaper.sanqin.com" },
      { title: "三峡都市报", domain: "dpaper.sxcm.net" },
      { title: "三峡晚报", domain: "sxwbepaper.hubeidaily.net" },
      { title: "三亚日报", domain: "epaper.sanyarb.com.cn" },
      { title: "厦门日报", domain: "xmnn.cn" },
      { title: "山东大众网", domain: "dzcom" },
      { title: "山西青年报", domain: "sxqnb.com.cn" },
      { title: "山西日报", domain: "epaper.sxrb.com" },
      { title: "山西新闻网", domain: "sxrb.com" },
      { title: "陕西日报", domain: "esb.sxdaily.com.cn" },
      { title: "商丘日报", domain: "epaper.cnsq.com.cn" },
      { title: "上海法制报", domain: "shfzb.com.cn" },
      { title: "上海证券报", domain: "paper.cnstock.com" },
      { title: "绍兴日报", domain: "epaper.sxnews.cn" },
      { title: "深圳特区报", domain: "sztqb.sznews.com" },
      { title: "深圳新闻网", domain: "sznews.com" },
      { title: "沈阳日报", domain: "epaper.syd.com.cn" },
      { title: "生活报", domain: "epaper.hljnews.cn" },
      { title: "生活日报", domain: "shrb.qlwb.com.cn" },
      { title: "十堰晚报", domain: "sywb.10yan.com" },
      { title: "石家庄日报", domain: "sjzrb.sjzdaily.com.cn" },
      { title: "石狮日报", domain: "epaper.ssrb.com.cn" },
      { title: "四川日报", domain: "epaper.scdaily.cn" },
      { title: "四平日报", domain: "spxww.com" },
      { title: "搜狐新闻", domain: "news.sohu.com" },
      { title: "随州日报", domain: "szrb.sz-news.com.cn" },
      { title: "太原日报", domain: "epaper.tywbw.com" },
      { title: "腾讯新闻", domain: "news.qq.com" },
      { title: "天津北方网", domain: "enorth.com.cn" },
      { title: "网易新闻", domain: "news.163.com" },
      { title: "潍坊晚报", domain: "wfwb.wfnews.com.cn" },
      { title: "温岭日报", domain: "wldaily.zjol.com.cn" },
      { title: "温州日报", domain: "newspaper.wzrb.com.cn" },
      { title: "文汇报", domain: "wenweipo.com" },
      { title: "武汉晨报", domain: "whcb.cjn.cn" },
      { title: "武汉晚报", domain: "whwb.cjn.cn" },
      { title: "武进日报", domain: "epaper.cz001.com.cn" },
      { title: "西安日报", domain: "epaper.xiancn.com" },
      { title: "西北信息报", domain: "xbxxb.joyhua.com" },
      { title: "西海都市报", domain: "epaper.tibet3.com" },
      { title: "西江都市报", domain: "xijiangdsb.com.cn" },
      { title: "咸阳日报", domain: "epaper.sxxynews.com" },
      { title: "现代快报", domain: "dz.xdkb.net" },
      { title: "香港商报", domain: "hkcd.com" },
      { title: "潇湘晨报", domain: "xxcb.cn" },
      { title: "新安晚报", domain: "epaper.ahwang.cn" },
      { title: "新华日报", domain: "xh.xhby.net" },
      { title: "新华网", domain: "xinhuanet.com" },
      { title: "新疆日报", domain: "epaper.xjdaily.com" },
      { title: "新京报", domain: "bjnews.com.cn" },
      { title: "新快报", domain: "epaper.xkb.com.cn" },
      { title: "新浪新闻", domain: "news.sina.com.cn" },
      { title: "新民网", domain: "xinmin.cn" },
      { title: "新民周刊", domain: "xmzk.xinmin.cn" },
      { title: "新晚报", domain: "xwb.my399.com" },
      { title: "新闻晨报", domain: "epaper.zhoudaosh.com" },
      { title: "新闻网站大全", domain: "my.1234wu.net" },
      { title: "信息时报", domain: "epaper.xxsb.com" },
      { title: "星岛环球网", domain: "stnn.cc" },
      { title: "邢台日报", domain: "xtrb.cn" },
      { title: "烟台晚报", domain: "shm.com.cn" },
      { title: "燕赵都市报", domain: "yzdsb.hebnews.cn" },
      { title: "燕赵晚报", domain: "yzwb.sjzdaily.com.cn" },
      { title: "央广网", domain: "cnr.cn" },
      { title: "央视网", domain: "news.cctv.com" },
      { title: "扬子晚报", domain: "yangtse.com" },
      { title: "扬子晚报", domain: "epaper.yzwb.net" },
      { title: "羊城地铁报", domain: "ycdtb.dayoo.com" },
      { title: "羊城晚报", domain: "ycwb.com" },
      { title: "宜兴日报", domain: "paper.cnyixing.cn" },
      { title: "右江日报", domain: "epaper.bsyjrb.cn" },
      { title: "榆林日报", domain: "szb.ylrb.com" },
      { title: "云南日报", domain: "yndaily.com" },
      { title: "云南信息报", domain: "ynxxb.com" },
      { title: "运城晚报", domain: "epaper.sxycrb.com" },
      { title: "在线读报", domain: "53bk.com" },
      { title: "长春日报", domain: "epaper.1news.cc" },
      { title: "长江日报", domain: "cjrb.cjn.cn" },
      { title: "长沙晚报", domain: "icswb.com" },
      { title: "浙江日报", domain: "zjdaily.zjol.com.cn" },
      { title: "证券日报", domain: "epaper.zqrb.cn" },
      { title: "证券时报", domain: "epaper.stcn.com" },
      { title: "郑州日报", domain: "zzrb.zynews.cn" },
      { title: "郑州晚报", domain: "zzwb.zynews.cn" },
      { title: "中国电子报", domain: "epaper.cena.com.cn" },
      { title: "中国经营报", domain: "dianzibao.cb.com.cn" },
      { title: "中国青年报", domain: "cyol.net" },
      { title: "中国日报", domain: "chinadaily.com.cn" },
      { title: "中国网", domain: "china.com.cn" },
      { title: "中国文明网", domain: "wenming.cn" },
      { title: "中国新闻网", domain: "chinanews.com" },
      { title: "中国新闻网", domain: "chinanews.com.cn" },
      { title: "中国新闻周刊网", domain: "inewsweek.cn" },
      { title: "中华网", domain: "china.com" },
      { title: "中山日报", domain: "zsnews.cn" },
      { title: "重庆华龙网", domain: "cqnews.net" },
      { title: "重庆青年报", domain: "cqqnb.net" },
      { title: "重庆日报", domain: "cqrb.cn" },
      { title: "重庆商报", domain: "e.chinacqsb.com" },
      { title: "重庆时报", domain: "cqsb.cqtimes.cn" },
      { title: "重庆晚报", domain: "cqwb.com.cn" },
      { title: "珠海特区报", domain: "zhuhaidaily.hizh.cn" },
      { title: "珠江商报", domain: "epaper.sc168.com" },
      { title: "珠江晚报", domain: "zjwb.com.cn" }
    ]
  },
  {
    category: "音乐网站",
    categoryI18nKey: "music",
    sites: [
      { title: "365音乐网", domain: "yue365.com" },
      { title: "51Ape", domain: "51ape.com" },
      { title: "A8原创音乐", domain: "a8.com" },
      { title: "DJ520", domain: "dj520.com" },
      { title: "DJ嗨吧", domain: "djhaiba.com" },
      { title: "DJ嗨嗨网", domain: "djkk.com" },
      { title: "DJ经典", domain: "abcd5.com" },
      { title: "DJ耶耶网", domain: "djye.com" },
      { title: "MVBOX", domain: "mvbox.cn" },
      { title: "QQ音乐", domain: "y.qq.com" },
      { title: "Y2002DJ舞曲", domain: "y2002.com" },
      { title: "yymp3音乐网", domain: "yymp3.com" },
      { title: "爱奇艺音乐", domain: "music.iqiyi.com" },
      { title: "唱吧", domain: "changba.com" },
      { title: "叮当音乐网", domain: "mtv123.com" },
      { title: "豆瓣FM", domain: "douban.fm" },
      { title: "豆瓣音乐", domain: "music.douban.com" },
      { title: "哼曲子找歌", domain: "midomi.com" },
      { title: "吉他社", domain: "jitashe.org" },
      { title: "九酷音乐网", domain: "9ku.com" },
      { title: "九天音乐", domain: "9sky.com" },
      { title: "酷狗", domain: "kugou.com" },
      { title: "酷我音乐", domain: "kuwo.cn" },
      { title: "荔枝FM", domain: "lizhi.fm" },
      { title: "咪咕音乐", domain: "music.migu.cn" },
      { title: "企鹅FM", domain: "fm.qq.com" },
      { title: "千千音乐", domain: "music.91q.com" },
      { title: "清风DJ音乐网", domain: "vvvdj.com" },
      { title: "蜻蜓fm", domain: "qingting.fm" },
      { title: "糖豆广场舞", domain: "tangdou.com" },
      { title: "听伴", domain: "tingban.cn" },
      { title: "网易云音乐", domain: "music.163.com" },
      { title: "无损音乐网", domain: "wusunyinyue.cn" },
      { title: "喜马拉雅", domain: "ximalaya.com" },
      { title: "新浪音乐", domain: "yue.sina.com.cn" },
      { title: "炫音音乐论坛", domain: "bbs.musicool.cn" },
      { title: "一听音乐网", domain: "1ting.com" },
      { title: "音乐巴士", domain: "yy8844.cn" },
      { title: "音乐客", domain: "yinyueke.net" },
      { title: "音悦网", domain: "yinyuetai.com" },
      { title: "优酷音乐", domain: "music.youku.com" },
      { title: "原创音乐基地", domain: "5sing.kugou.com" },
      { title: "云听", domain: "radio.cn" }
    ]
  },
  {
    category: "游戏网站",
    categoryI18nKey: "games",
    sites: [
      { title: "17173", domain: "17173.com" },
      { title: "07073网页游戏", domain: "07073.com" },
      { title: "178游戏网", domain: "178.com" },
      { title: "17yy经典小游戏", domain: "17yy.com" },
      { title: "18183手游", domain: "18183.com" },
      { title: "265G网页游戏", domain: "265g.com" },
      { title: "360游戏", domain: "wan.360.cn" },
      { title: "37游戏", domain: "37.com" },
      { title: "3DM游戏网", domain: "3dmgame.com" },
      { title: "3YX游戏交易平台", domain: "3yx.com" },
      { title: "4399网页游戏", domain: "web.4399.com" },
      { title: "5173游戏交易", domain: "5173.com" },
      { title: "51游戏", domain: "51.com" },
      { title: "52PK游戏网", domain: "52pk.com" },
      { title: "91玩网页游戏", domain: "91wan.com" },
      { title: "a9vg电玩部落", domain: "bbs.a9vg.com" },
      { title: "C5GAME", domain: "c5game.com" },
      { title: "crazygames", domain: "crazygames.com" },
      { title: "DD373", domain: "dd373.com" },
      { title: "Flash游戏中心", domain: "game.flash.cn" },
      { title: "JJ比赛", domain: "jj.cn" },
      { title: "nds中文网", domain: "nds.tgbus.com" },
      { title: "NGA玩家社区", domain: "bbs.nga.cn" },
      { title: "Origin", domain: "origin.com" },
      { title: "PSP中文网", domain: "psp.tgbus.com" },
      { title: "QQ游戏", domain: "qqgame.qq.com" },
      { title: "steam", domain: "store.steampowered.com" },
      { title: "TapTap", domain: "taptap.com" },
      { title: "VS竞技游戏平台", domain: "vsa.com.cn" },
      { title: "暴雪游戏平台", domain: "battlenet.com.cn" },
      { title: "边锋棋牌", domain: "gameabc.com" },
      { title: "波克城市", domain: "pook.com" },
      { title: "彩虹堂小游戏", domain: "caihongtang.com" },
      { title: "畅玩空间", domain: "wo1wan.com" },
      { title: "达龙云游戏", domain: "dalongyun.com" },
      { title: "当乐手机游戏", domain: "d.cn" },
      { title: "电玩巴士", domain: "tgbus.com" },
      { title: "斗鱼云游戏", domain: "cloudgame.douyu.com" },
      { title: "逗游游戏网", domain: "doyo.cn" },
      { title: "凤凰游戏", domain: "fhyx.com" },
      { title: "搞趣网", domain: "gao7.com" },
      { title: "共创世界", domain: "ccw.site" },
      { title: "光宇游戏", domain: "gyyx.cn" },
      { title: "果蔬连连看", domain: "sgllk.com" },
      { title: "浩方对战平台", domain: "cga.com.cn" },
      { title: "红白机游戏", domain: "yikm.net" },
      { title: "虎牙云游戏", domain: "yowa.huya.com" },
      { title: "欢乐斗地主", domain: "hlddz.huanle.qq.com" },
      { title: "欢乐园网页游戏", domain: "t.hly.com" },
      { title: "黄金岛", domain: "80166.com" },
      { title: "家用游戏博物馆", domain: "famicn.com" },
      { title: "简单百宝箱", domain: "jdbbx.com" },
      { title: "交易猫", domain: "jiaoyimao.com" },
      { title: "街机中国", domain: "mamecn.com" },
      { title: "金山游戏", domain: "xoyo.com" },
      { title: "九游", domain: "9game.cn" },
      { title: "久游网", domain: "9you.com" },
      { title: "巨人网络", domain: "ztgame.com" },
      { title: "空中网", domain: "kongzhong.com" },
      { title: "老K游戏", domain: "lkgame.com" },
      { title: "连连看", domain: "4399.com" },
      { title: "联众游戏", domain: "ourgame.com" },
      { title: "猎豹游戏大厅", domain: "play.wan.liebao.cn" },
      { title: "梦幻西游藏宝阁", domain: "xyq.cbg.163.com" },
      { title: "咪咕快游", domain: "migu.cn" },
      { title: "拇指玩", domain: "muzhiwan.com" },
      { title: "牛游戏", domain: "newyx.net" },
      { title: "琵琶网", domain: "pipaw.com" },
      { title: "杉果游戏", domain: "sonkwo.com" },
      { title: "闪艺", domain: "3000.com" },
      { title: "盛大游戏", domain: "sdo.com" },
      { title: "世纪天成", domain: "tiancity.com" },
      { title: "搜狐畅游", domain: "changyou.com" },
      { title: "索尼游戏", domain: "asia.playstation.com" },
      { title: "台服战网", domain: "tw.battle.net" },
      { title: "淘手游", domain: "taoshouyou.com" },
      { title: "腾讯Wegame", domain: "wegame.com" },
      { title: "腾讯先锋", domain: "gamer.qq.com" },
      { title: "腾讯游戏", domain: "games.qq.com" },
      { title: "天翼云游戏", domain: "play.cn" },
      { title: "同城游戏", domain: "uc108.com" },
      { title: "完美世界", domain: "wanmei.com" },
      { title: "网龙", domain: "nd.com.cn" },
      { title: "网易游戏", domain: "game.163.com" },
      { title: "网易云游戏", domain: "cg.163.com" },
      { title: "我爱小游戏", domain: "52xyx.net" },
      { title: "新浪-单机游戏", domain: "games.sina.com.cn" },
      { title: "新浪电竞", domain: "dj.sina.com.cn" },
      { title: "新浪新手卡", domain: "ka.sina.com.cn" },
      { title: "叶子猪", domain: "yzz.cn" },
      { title: "一起玩", domain: "17game.com" },
      { title: "悠悠游戏服务网", domain: "uu898.com" },
      { title: "游久网", domain: "uuu9.com" },
      { title: "游民星空", domain: "gamersky.com" },
      { title: "游戏狗", domain: "gamedog.cn" },
      { title: "游侠网", domain: "ali213.net" },
      { title: "游迅网", domain: "yxdown.com" },
      { title: "育碧中国", domain: "ubisoft.com.cn" },
      { title: "在线DOS游戏", domain: "dos.zczc.cz" },
      { title: "在线拼图小游戏", domain: "puzzle8.com" },
      { title: "中国游戏中心", domain: "chinagames.net" },
      { title: "中青宝", domain: "zqgame.com" },
      { title: "租号玩", domain: "zuhaowan.com" }
    ]
  },
  {
    category: "招聘网站",
    categoryI18nKey: "recruitment",
    sites: [
      { title: "1010兼职网", domain: "1010jz.com" },
      { title: "58同城招聘", domain: "58.com" },
      { title: "BOSS直聘", domain: "zhipin.com" },
      { title: "百度招聘搜索", domain: "zhaopin.baidu.com" },
      { title: "大街网", domain: "dajie.com" },
      { title: "高校人才网", domain: "gaoxiaojob.com" },
      { title: "海投网", domain: "haitou.cc" },
      { title: "兼职吧", domain: "jianzhi8.com" },
      { title: "兼职猫", domain: "jianzhimao.com" },
      { title: "金柚网", domain: "joyowo.com" },
      { title: "看准网", domain: "kanzhun.com" },
      { title: "拉勾网", domain: "lagou.com" },
      { title: "猎聘网", domain: "liepin.com" },
      { title: "南方人才网", domain: "job168.com" },
      { title: "前程无忧", domain: "51job.com" },
      { title: "实习僧", domain: "shixiseng.com" },
      { title: "梧桐果", domain: "wutongguo.com" },
      { title: "五百丁", domain: "500d.me" },
      { title: "应届毕业生求职网", domain: "yjbys.com" },
      { title: "应届生求职网", domain: "yingjiesheng.com" },
      { title: "鱼泡网", domain: "yupao.com" },
      { title: "职业圈", domain: "job592.com" },
      { title: "职友集", domain: "jobui.com" },
      { title: "智联招聘网", domain: "zhaopin.com" },
      { title: "智通人才网", domain: "job5156.com" },
      { title: "中国人才热线", domain: "cjol.com" },
      { title: "中华英才网", domain: "chinahr.com" },
      { title: "卓博人才网", domain: "jobcn.com" }
    ]
  }
] as DomainCategoryBlock[]

/** 策略里域名分类静态库：日文专版构建用 JP 站点集，其余用大陆版 */
export const domainCategoryWebsiteData: DomainCategoryBlock[] = IS_JP_ONLY_BUILD
  ? domainCategoryWebsiteDataJP
  : domainCategoryWebsiteDataCN

export function getDomainCategoryById(id: number): DomainCategoryBlock | undefined {
  if (!Number.isFinite(id) || id < 1) return undefined
  return domainCategoryWebsiteData[id - 1]
}

/** 静态库域名统一为 `*.` 子域通配前缀（与策略合并 url 一致） */
export function toLibraryWildcardDomain(bareOrPrefixed: string): string {
  const d = String(bareOrPrefixed).trim()
  if (!d) return d
  if (d.startsWith('*.')) return d
  return `*.${d}`
}

export function getDomainsForCategoryId(id: number): string[] {
  const b = getDomainCategoryById(id)
  if (!b?.sites?.length) return []
  return b.sites.map((s) => toLibraryWildcardDomain(String(s.domain).trim())).filter(Boolean)
}

export function buildAllKnownDomainsSet(): Set<string> {
  const s = new Set<string>()
  for (const b of domainCategoryWebsiteData) {
    for (const x of b.sites) {
      const d = String(x.domain).trim()
      if (d) s.add(toLibraryWildcardDomain(d))
    }
  }
  return s
}

/** 拆成静态库内域名（走分类选择）与手写域名（仅输入框） */
export function splitLibraryAndManualUrls(raw: string[]): { library: string[]; manual: string[] } {
  const known = buildAllKnownDomainsSet()
  const library: string[] = []
  const manual: string[] = []
  for (const u of raw) {
    const s = String(u).trim()
    if (!s) continue
    if (known.has(s)) {
      library.push(s)
      continue
    }
    const starred = toLibraryWildcardDomain(s)
    if (known.has(starred)) library.push(starred)
    else manual.push(s)
  }
  return { library, manual }
}

/** 根据合并后的域名集合计算「整分类全选」的 category_ids */
export function categoryIdsFullySelectedInUrlSet(urlSet: Set<string>): number[] {
  const ids: number[] = []
  domainCategoryWebsiteData.forEach((_, i) => {
    const id = i + 1
    const doms = getDomainsForCategoryId(id)
    if (doms.length && doms.every((d) => urlSet.has(d))) ids.push(id)
  })
  return ids
}

/** 与旧版下拉 value 一致：1..N */
export function domainCategoryOptions(t: (key: string) => string): { label: string; value: number }[] {
  return domainCategoryWebsiteData.map((b, i) => ({
    value: i + 1,
    label: t(`accessRestriction.domainCategory.${b.categoryI18nKey}`),
  }))
}

export function domainCategoryLabelById(
  t: (key: string) => string,
  id: number,
  fallbackName?: string,
): string {
  const b = getDomainCategoryById(id)
  if (b?.categoryI18nKey) return t(`accessRestriction.domainCategory.${b.categoryI18nKey}`)
  return b?.category ?? fallbackName ?? String(id)
}
